import type { IconBaseProps } from "./Icon";

export default function PlusIcon({ className, color }: IconBaseProps) {
  return (
    <svg
      style={{ color: color }}
      className={className}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9922 13.537H13.1556V19.3736H11.2101V13.537H5.37354V11.5915H11.2101V5.75488H13.1556V11.5915H18.9922V13.537Z"
        fill="currentColor"
      />
    </svg>
  );
}
